module.exports = __webpack_public_path__ + "img/ypicture.f8663433.png";